import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatIconRegistry } from '@angular/material/icon';
import { MobileDetectorService } from './core/services/mobile-detector.service';
import { ApplicationInsightsService } from './core/services/application-insights.service';
import { ApplicationInsightsRouterService } from './core/services/application-insights-router.service';
import { IntercomService } from './core/services/intercom.service';
import { environment } from '../environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false
})
export class AppComponent {
  private readonly matIconReg = inject(MatIconRegistry);
  private readonly http = inject(HttpClient);
  private readonly mobileDetectorService = inject(MobileDetectorService);
  private readonly appInsightsService = inject(ApplicationInsightsService);
  private readonly appInsightsRouter = inject(ApplicationInsightsRouterService);
  private readonly intercomService = inject(IntercomService);

  constructor() {
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');
    this.appInsightsRouter.initialize();

    this.http.get<{ data: { version: string; environment: string } }>(`${environment.apiUrl}/version`).subscribe({
      next: (res) => console.log(`[API] Version: ${res.data.version} (${res.data.environment})`),
    });

    this.intercomService.initialize();
  }
}
